import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define interfaces for type safety
interface Favourite {
  entity: string;
  title: string;
  description: string;
  [key: string]: any; // For any additional properties
}

interface UpdateFavouritePayload {
  entity: string;
  title?: string;
  description?: string;
}

const initialState: Favourite[] = [];

export const myFavouritesSlice = createSlice({
  name: 'myFavourites',
  initialState,
  reducers: {
    setFavourites: (state, action: PayloadAction<Favourite[]>) => {
      return action.payload || [];
    },
    addFavourite: (state, action: PayloadAction<Favourite[]>) => {
      state.push(...(action.payload || []));
    },
    removeFavourite: (state, action: PayloadAction<string[]>) => {
      return state.filter((fav) => !action.payload.includes(fav.entity));
    },
    updateFavourite: (state, action: PayloadAction<UpdateFavouritePayload>) => {
      const { entity, title, description } = action.payload;
      const favourite = state.find((fav) => fav.entity === entity);
      if (favourite) {
        if (title !== undefined) favourite.title = title;
        if (description !== undefined) favourite.description = description;
      }
    }
  }
});

export const { setFavourites, addFavourite, removeFavourite, updateFavourite } = myFavouritesSlice.actions;
export default myFavouritesSlice.reducer;
